import { Button, Divider, Modal, Typography } from "antd";
import { useState } from "react";
import DownloadIcon from "../../../assets/icons/download.svg";
import { Image } from "react-bootstrap";
import ModelFileUpload from "../../ModelFileUpload/ModelFileUpload";
import "./FileUploadModal.css";
import { useDispatch, useSelector } from "react-redux";
import { csvModelFileTemplates } from "../../../utilities/common";
import { updateCountGeneratedModels, updateInitialGeneratedModels } from "../../../service/apiSlices/staticApi";
import uploadCardImage from "../../../assets/images/upload-card-image.png";
import fileIcon from "../../../assets/icons/fileIcon.svg";
import { useTranslation } from "react-i18next";
import TextWithHTML from "../../TextWithHTML/TextWIthHTML";
import { useModalContainer } from "../../../utilities/Models/modelUtils";
import { ROUTES } from "../../../utilities/Constants/Constants";
import { useNavigate } from "react-router-dom";

const FileUploadModal = ({ type, isModalOpen, setIsModalOpen }: { type: string, isModalOpen: boolean, setIsModalOpen: () => void }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { countGeneratedModels } = useSelector((state: any) => state.static);
  const { t } = useTranslation("common");
  const [clearFileUpload, setClearFileUpload] = useState(false);
  const modalContainer = useModalContainer();

  const handleOnClose = (isUpload: boolean) => {
    setClearFileUpload(true);
    setIsModalOpen();
  };

  const handleOnSuccessFileUpload = () => {
    dispatch(updateCountGeneratedModels(countGeneratedModels + 1));
    dispatch(updateInitialGeneratedModels([]));
    handleOnClose(true);
  };

  return (
    <>
      <p
        className="card-link"
      >
        {t('uploadOptions.uploadCSV.modalTitle')}
      </p>
      <Modal
        title={false}
        footer={false}
        centered
        open={isModalOpen}
        onCancel={(e: any) => { handleOnClose(false); e.stopPropagation() }}
        className="upload-modal"
        width={450}
        mask={false}
        destroyOnClose={true}
        getContainer={() => modalContainer || document.body}
      >
        <div className="row">
          <div className="col-md-12">
            <div className="gap-5 h-100 d-flex flex-column justify-content-between align-content-between">
              <div>
                <Typography.Title className="modal-title" >{t('uploadOptions.uploadCSV.modalTitle')}</Typography.Title>
                <Typography.Paragraph ellipsis={{ rows: 5 }} className="modal-description">
                  <TextWithHTML content={t('uploadOptions.uploadCSV.modalDescription')} />
                </Typography.Paragraph>
                <Image src={uploadCardImage} alt="upload" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 justify-content-center g-0">
          <div className="col-md-5 d-flex mt-2">
            <div className="w-100">
              <div className="">
                <h6 className="text-start template-heading">{t('templates')}</h6>
              </div>
              <Button
                className="download-template-button"
                size="large"
                download={true}
                href={csvModelFileTemplates.twoColumns}
              >
                <div className="icon-wrapper">
                  <img src={DownloadIcon} alt="Download" />
                </div>
                <div className="button-content-wrapper">
                  <img src={fileIcon} alt="Download" />
                  {t('templateOne')}
                </div>
              </Button>
              <Button
                className="download-template-button"
                size="large"
                href={csvModelFileTemplates.threeColumns}
                download={true}
              >
                <div className="icon-wrapper">
                  <img src={DownloadIcon} alt="Download" />
                </div>
                <div className="button-content-wrapper">
                  <img src={fileIcon} alt="Download" />
                  {t('templateTwo')}
                </div>
              </Button>
            </div>
          </div>
          <div className="col-md-1 d-flex p-0 justify-content-center mt-2">
            <Divider type="vertical" className="divider-upload" />
          </div>
          <div className="col-md-6 d-flex justify-content-center align-items-center mt-2">
            <div className="custom-model-file-upload-wrapper w-100">
              <ModelFileUpload
                params={{
                  format_type: "1",
                  embedding_name: "new-modal", // #TODO: Remove embedding_name after the param is removed from fileUpload api
                  upload_file_format: "1",
                }}
                hint=""
                onSuccess={handleOnSuccessFileUpload}
                onError={() => { }}
                clearFileUpload={clearFileUpload}
              />
              < Button
                className="viewModel-btn w-100"
                onClick={() => navigate(ROUTES.VIEWMODELS)}
              >
                {t("buttons.viewModel")}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FileUploadModal;
